// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__22Wd_","info":"Note_info__2AVSO","note":"Note_note__2ZE3n","actions":"Note_actions__2_tfo"};